import { NUMBERED_HEADING } from './normalizePastedText'

const escapeHtml = (value: string) =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

const adjacentLine = (lines: string[], index: number, step: number) => {
  for (let i = index + step; i >= 0 && i < lines.length; i += step) {
    const line = lines[i]
    if (line !== undefined && line.trim() !== '') return line
  }
  return undefined
}

/**
 * A numbered line is a heading only when it stands on its own - consecutive
 * numbered lines are an ordered list and keep their numbering as plain text.
 */
const isHeading = (line: string, lines: string[], index: number) => {
  if (!NUMBERED_HEADING.test(line)) return false

  return ![adjacentLine(lines, index, -1), adjacentLine(lines, index, 1)].some(
    neighbour => neighbour !== undefined && NUMBERED_HEADING.test(neighbour)
  )
}

export function pastedTextToHtml(text: string): string {
  const lines = text.split('\n')
  while (lines.length > 0 && lines[lines.length - 1]?.trim() === '') lines.pop()

  return lines
    .map((line, index) => {
      if (line.trim() === '') return '<p><br></p>'

      const content = escapeHtml(line)
      return isHeading(line, lines, index)
        ? `<h3>${content}</h3>`
        : `<p>${content}</p>`
    })
    .join('')
}
